var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuBar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 7C22.5 7.27614 22.2761 7.5 22 7.5L6 7.5C5.72386 7.5 5.5 7.27614 5.5 7C5.5 6.72386 5.72386 6.5 6 6.5L22 6.5C22.2761 6.5 22.5 6.72386 22.5 7ZM22.5 14C22.5 14.2761 22.2761 14.5 22 14.5L6 14.5C5.72386 14.5 5.5 14.2761 5.5 14C5.5 13.7239 5.72386 13.5 6 13.5H22C22.2761 13.5 22.5 13.7239 22.5 14ZM14.5 21C14.5 21.2761 14.2761 21.5 14 21.5H6C5.72386 21.5 5.5 21.2761 5.5 21C5.5 20.7239 5.72386 20.5 6 20.5H14C14.2761 20.5 14.5 20.7239 14.5 21Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuBar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu-bar.7a687725.svg";
export { ForwardRef as ReactComponent };